module.exports = __webpack_public_path__ + "static/media/cycling.b011daca.svg";